export default __webpack_public_path__ + "static/media/36I-114287_-20974_0.6ebcffee.jpg";